import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id", "disabled", "placeholder", "required", "max", "min"];
import { fromNumberInput, toNumber } from "./fieldValues";
import { useFieldControl, useFieldModel } from "./useFieldControl";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlNumber',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const { fieldOptions, emitChange, onFocus, onBlur } = useFieldControl(props, emit, 'FieldControlNumber');
        // the browser reports an unparsable input as a string
        const model = useFieldModel(() => toNumber(props.data));
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                onInput: _cache[1] || (_cache[1] = ($event) => (_unref(emitChange)(_unref(fromNumberInput)(_unref(model))))),
                onFocus: _cache[2] || (_cache[2] =
                    //@ts-ignore
                    (...args) => (_unref(onFocus) && _unref(onFocus)(...args))),
                onBlur: _cache[3] || (_cache[3] =
                    //@ts-ignore
                    (...args) => (_unref(onBlur) && _unref(onBlur)(...args))),
                type: "number",
                step: "any",
                id: __props.fieldId,
                disabled: _unref(fieldOptions).disabled ?? undefined,
                placeholder: _unref(fieldOptions).placeholder ?? undefined,
                required: _unref(fieldOptions).required ?? undefined,
                max: _unref(fieldOptions).max ?? undefined,
                min: _unref(fieldOptions).min ?? undefined,
                class: "form__control"
            }, null, 40, _hoisted_1)), [
                [
                    _vModelText,
                    _unref(model),
                    void 0,
                    { number: true }
                ]
            ]);
        };
    }
});
